import { ReactNode } from "react";
import { Modal, ActionIcon, Title } from "rizzui";
import { PiX } from "react-icons/pi";

interface ModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  title: string | ReactNode;
  children: ReactNode;
  containerClassName?: string;
  showCloseButton?: boolean;
  titleClassName?: string;
}

/**
 * Modal Wrapper Component
 * Provides a consistent interface for all modals in the application
 */
export default function ModalWrapper({
  isOpen,
  onClose,
  title,
  children,
  containerClassName = "",
  showCloseButton = true,
  titleClassName = "",
}: ModalWrapperProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      containerClassName={`${containerClassName}`}
    >
      <div className="relative p-6 bg-white rounded-lg shadow-lg">
        <div className="flex items-center justify-between mb-6">
          <Title
            as="h2"
            className={`text-xl font-semibold text-center w-full ${titleClassName}`}
          >
            {title}
          </Title>
          {showCloseButton && (
            <ActionIcon
              variant="text"
              onClick={onClose}
              className="h-8 w-8 absolute right-4 top-4"
            >
              <PiX className="h-6 w-6" />
            </ActionIcon>
          )}
        </div>
        {children}
      </div>
    </Modal>
  );
}
